import { UseMutateAsyncFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { getNetworkElementVesCuPath } from '@api/networkElements';

import { IId } from '@interfaces/common/common';
import { IPath } from '@interfaces/networkElements/networkElements';

import { NETWORK_ELEMENTS_VES_CU_PATH } from '@constants/queryKeys';

interface IUseMutateNetworkElementsGetVesPathCuReturned {
	getPathCu: UseMutateAsyncFunction<IPath, any, IId<string>, any>;
	isLoadingGetPathCu: boolean;
}

const useMutateNetworkElementsGetVesPathCu = (): IUseMutateNetworkElementsGetVesPathCuReturned => {
	const {
		mutateAsync,
		isLoading,
	} = useMutation<IId, IPath>({
		mutationKey: [NETWORK_ELEMENTS_VES_CU_PATH],
		mutationFn: getNetworkElementVesCuPath,
	});

	return {
		getPathCu: mutateAsync,
		isLoadingGetPathCu: isLoading,
	};
};

export default useMutateNetworkElementsGetVesPathCu;
